<ng-container *ngIf="environment !== 'prod'">
  <div class="env__lbl">
    <span *ngFor="let item of [].constructor(16); let i = index">{{
      environment
    }}</span>
  </div>
</ng-container>
